import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result } from '@digibricks/core';
import { CreateFileStorageUseCase } from '../create-file-storage.usecase';
export var CREATE_FORM_THUMBNAIL_USE_CASE = 'CREATE_FORM_THUMBNAIL_USE_CASE';
export var CreateFormThumbnailUseCase = /*#__PURE__*/function (_CreateFileStorageUse) {
  _inherits(CreateFormThumbnailUseCase, _CreateFileStorageUse);

  var _super = _createSuper(CreateFormThumbnailUseCase);

  function CreateFormThumbnailUseCase(fileStorageRepository, externalFileStorageRepository) {
    var _this;

    _classCallCheck(this, CreateFormThumbnailUseCase);

    _this = _super.call(this, fileStorageRepository, externalFileStorageRepository);
    _this.fileStorageRepository = fileStorageRepository;
    _this.externalFileStorageRepository = externalFileStorageRepository;
    return _this;
  }

  _createClass(CreateFormThumbnailUseCase, [{
    key: "createFile",
    value: function () {
      var _createFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fileStorageRepository.createFormThumbnail(input);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createFile(_x) {
        return _createFile.apply(this, arguments);
      }

      return createFile;
    }()
  }, {
    key: "validate",
    value: function validate(input) {
      var formId = input.formId;
      var guardCollections = [{
        argument: formId,
        argumentName: 'Form ID'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var baseInputResultOrError, resultOrError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                baseInputResultOrError = _get(_getPrototypeOf(CreateFormThumbnailUseCase.prototype), "validateBaseInput", this).call(this, input);

                if (!baseInputResultOrError.isFailure) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", Result.fail(baseInputResultOrError.error));

              case 3:
                resultOrError = this.validate(input);

                if (!resultOrError.isFailure) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", Result.fail(resultOrError.error));

              case 6:
                _context2.next = 8;
                return this.uploadFile(input);

              case 8:
                return _context2.abrupt("return", _context2.sent);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function buildUseCase(_x2) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CreateFormThumbnailUseCase;
}(CreateFileStorageUseCase);